import React, { Component } from "react";
import EmpresaContext from "../../context";
import { Empresa } from "smart-imob-types";
import { BuilderImg, HBT } from "../../builder-context";

class AboutUs extends Component {
  context!: Empresa;
  render() {
    return (
      <div className="about-area pd-bottom-90">
        <div className="container">
          <div className="row">
            {!!this.context.logo && (
              <div className="col-lg-6 mb-4 mb-lg-0">
                <div className="shape-image-list-wrap">
                  <div className="shape-image-list left-top">
                    {this.context.info_gen &&
                    this.context.info_gen.video_sobre ? (
                      <video
                        className="shadow-img"
                        autoPlay={
                          this.context.info_gen.video_sobre_autoplay || true
                        }
                        muted={this.context.info_gen.video_sobre_muted || true}
                        controls={
                          this.context.info_gen.video_sobre_controls || false
                        }
                        loop
                        src={this.context.info_gen.video_sobre}
                      />
                    ) : (
                      <img
                        className="shadow-img"
                        {...BuilderImg("bb_about_foto")}
                        src={
                          this.context["bb_about_foto"] ||
                          (this.context.info_gen &&
                            this.context.info_gen.foto_sobre) ||
                          this.context.logo
                        }
                        alt={`Logo ${this.context.nome_fantasia ||
                          this.context.nome}`}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
            {!!(
              this.context.info_gen &&
              (this.context.info_gen.sobre || this.context["bb_text_sobre"])
            ) && (
              <div className="col-lg-6 align-self-center">
                <div className="section-title pd-left mb-0">
                  <h5 className="sub-title" {...HBT("bb_sobre_title")}>
                    {this.context["bb_sobre_title"] || "Sobre"}
                  </h5>
                  <h2 className="title" {...HBT("bb_sub_title")}>
                    {this.context["bb_sub_title"] ||
                      this.context.info_gen.titulo_sobre ||
                      "O que nós somos?"}
                  </h2>
                  <p {...HBT("bb_text_sobre")}>
                    {this.context["bb_text_sobre"] ||
                      this.context.info_gen.sobre}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

AboutUs.contextType = EmpresaContext;

export default AboutUs;
